import { render, staticRenderFns } from "./CustomerDetailService.vue?vue&type=template&id=6a957046&scoped=true&"
import script from "./CustomerDetailService.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a957046",
  null
  
)

export default component.exports